module.exports = __webpack_public_path__ + "img/02.c2e1e6c5.png";